/// <reference path="../../../node_modules/@types/globalize/index.d.ts" />
/// <reference path="../htmlhelpers/htmlhelpers.ts" />

namespace Teva {
    export interface SortableOptions {
        ItemSelector?: any;
        HandleSelector: any;
        OnChange?: any;
        Threshold?: number;
        PreserveWidth?: boolean;
    }

    export class Sortable {
        private static GetDefaults(): SortableOptions {
            return <SortableOptions>{
                ItemSelector: "> tr",
                HandleSelector: null,
                Threshold: 10,
                PreserveWidth: false
            };
        }

        static Enable($Elements: JQuery, Options: SortableOptions) {
            Options = $.extend({}, Sortable.GetDefaults(), Options);

            $Elements.each(function () {
                Sortable.InnerEnable($(this), Options);
            });
        }
        static InnerEnable($Element: JQuery, Options: SortableOptions) {
            if ($Element.data("sortable") == "1")
                return;

            $Element.data("sortable", "1");

            var $Cloned;
            var MovedElement_OriginalZIndex;

            var $MovedElement;
            var StartTop;
            var StartIndex;
            var CurrentIndex;

            $Element.closest("table").css("position", "relative");
            $Element.css("position", "relative");

            $Element.on("touchstart.sortable mousedown.sortable", Options.HandleSelector, function (Event) {
                var IsTouch = Event.type == "touchstart";
                if (Event.which != 1 && !IsTouch)
                    return;

                $(document).on(!IsTouch ? "mouseup.sortable" : "touchend.sortable", function (Event) {
                    MouseUp(Event);
                });

                $Cloned = null;
                var Map = Sortable.GetMap(Options, $Element);

                var $this = $(this);
                $MovedElement = $this.parentsUntil($Element).last();
                if ($MovedElement.length == 0 && $this.parent()[0] == $Element[0])
                    $MovedElement = $this;
                if (Options.PreserveWidth) {
                    $MovedElement.data("sortable-originalwidth", $MovedElement.css("width"));
                    $MovedElement.css("width", $MovedElement.width());
                }
                $MovedElement.data("sortable-originalzindex", $MovedElement.css("z-index"));
                $MovedElement.css("z-index", ($MovedElement.css("z-index") == "auto" ? "0" : $MovedElement.css("z-index")) + 1);
                $MovedElement.data("sortable-thresholdpassed", null);
                var IsTable = $MovedElement[0].tagName == "TR";
                StartTop = $MovedElement.position().top;

                var StartY = IsTouch ? (<any>Event.originalEvent).touches[0].pageY : Event.pageY;
                StartIndex = Sortable.GetIndex(Map, StartY - $Element.offset().top);

                CurrentIndex = StartIndex;
                $(document).on(!IsTouch ? "mousemove.sortable" : "touchmove.sortable", function (Event) {
                    var PageY = IsTouch ? (<any>Event.originalEvent).touches[0].pageY : Event.pageY;
                    var NewIndex = Sortable.GetIndex(Map, PageY - $Element.offset().top);
                    var NewTop = PageY - StartY + StartTop;
                    if (!$MovedElement.data("sortable-thresholdpassed")) {
                        if (Math.abs(NewTop - StartTop) >= Options.Threshold)
                            $MovedElement.data("sortable-thresholdpassed", true);
                        else
                            return;
                    }
                    if ($Cloned == null) {
                        if (IsTable) {
                            $Cloned = $
                                (document.createElement('tr')
                                    .addClass("og-sortable-cloned"))
                                .css("width", $MovedElement.width())
                                .css("height", $MovedElement.height())
                                .insertAfter($MovedElement);
                            $("> td", $MovedElement).each(function () {
                                var $this = $(this);
                                $Cloned.append($(document.createElement('td'))
                                    .attr("class", this.className)
                                    .css("width", $this.outerWidth())
                                    .css("height", $this.outerHeight()));

                                $this
                                    .data("original-width", $this.css("width"))
                                    .css("min-width", $this.outerWidth());
                            });
                        }
                        else {
                            $Cloned = $
                                (document.createElement('div')
                                    .addClass("og-sortable-cloned"))
                                .css("width", $MovedElement.width())
                                .css("height", $MovedElement.height())
                                .insertAfter($MovedElement);
                        }
                    }
                    $MovedElement
                        .css("position", "absolute")
                        .css("top", NewTop);

                    if (CurrentIndex == NewIndex)
                        return;

                    if (CurrentIndex == NewIndex - 1)
                        $MovedElement.insertAfter($($("> :not(.og-sortable-cloned)", $Element)[NewIndex]));
                    else
                        $MovedElement.insertBefore($($("> :not(.og-sortable-cloned)", $Element)[NewIndex]));
                    $Cloned.insertAfter($MovedElement);
                    CurrentIndex = NewIndex;
                });
                Event.preventDefault();
            });

            var MouseUp = function (Event) {
                var IsTouch = Event.type == "touchend";
                if ($Cloned != null) {
                    $Cloned.remove();
                    $Cloned = null;
                }
                if ($MovedElement != null) {
                    if (Options.PreserveWidth) {
                        $MovedElement
                            .css("width", $MovedElement.data("sortable-originalwidth"))
                            .data("sortable-originalwidth", null);
                    }
                    $MovedElement
                        .css("z-index", $MovedElement.data("sortable-originalzindex"))
                        .data("sortable-originalzindex", null);
                    if ($MovedElement != null) {
                        $MovedElement
                            .css("top", "")
                            .css("position", "");
                        $("> td", $MovedElement).each(function () {
                            var $this = $(this);
                            $this
                                .css("width", $this.data("original-width") == null ? "" : $this.data("original-width"))
                                .data("original-width", null);
                        });
                        setTimeout(function () {
                            $MovedElement.data("sortable-thresholdpassed", null);
                            $MovedElement = null;
                        }, 0);
                    }
                }

                $(document).off("touchmove.sortable mousemove.sortable touchend.sortable mouseup.sortable");
                $Element.off("touchend.sortable mouseup.sortable");

                if ($MovedElement != null) {
                    $MovedElement.css('z-index', MovedElement_OriginalZIndex);
                    if (Options.OnChange != null && CurrentIndex != StartIndex)
                        Options.OnChange($MovedElement);
                }

                StartIndex = null;
                StartTop = null;
                CurrentIndex = null;

                if ($MovedElement != null && $MovedElement.data("sortable-thresholdpassed")) {
                    Event.stopPropagation();
                    Event.preventDefault();
                }
                else if (IsTouch) {
                    var ElementToMouseup;
                    if ($(Event.target).is(":focusable"))
                        ElementToMouseup = $(Event.target);
                    else
                        ElementToMouseup = $(":focusable:first", Event.target);
                    if (ElementToMouseup.length == 0)
                        ElementToMouseup = $(Event.target);
                    ElementToMouseup.trigger("mouseup");
                    ElementToMouseup.trigger("click");
                }
            };

            $Element.on("touchend.sortable mouseup.sortable", Options.HandleSelector, function (Event) {
                MouseUp(Event);
            });
        }

        private static GetMap(Options: SortableOptions, Element) {
            var Map = new Array();
            var Top = 0;
            $(Options.ItemSelector, $(Element)).each(function () {
                var $this = $(this);
                Map.push({
                    Element: $this,
                    Top: Top,
                    Height: $this.outerHeight()
                });
                Top += $this.outerHeight();
            });
            return Map;
        }

        private static GetIndex(Map, Top) {
            if (Top < Map[0].Top)
                return 0;
            for (var i = 0; i < Map.length; i++) {
                if (Top >= Map[i].Top && Top < Map[i].Top + Map[i].Height)
                    return i;
            }
            return Map.length - 1;
        }
    }
}